import { Grid } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"

import { FormGroup } from "~/pages/Admin/components/FormGroup"
import { FormRow } from "~/pages/Admin/components/FormRow"
import { RenderField } from "~/pages/Admin/components/RenderField"
import { FormElement } from "~/pages/Admin/components/form.types"

export const RenderFormSection = <T extends Record<string, unknown>>({
  element,
  form,
}: {
  element: FormElement
  form: UseFormReturnType<T>
  index: number
}) => {
  switch (element.type) {
    case "row":
      return <FormRow rowConfig={element} form={form} />
    case "group":
      return <FormGroup groupConfig={element} form={form} />
    default:
      return (
        <Grid.Col span={element.span || 12}>
          <RenderField field={element} form={form} />
        </Grid.Col>
      )
  }
}
